import Utils from 'services/utils';

function responseDataExtractor(response) {
    return response.data;
}

export default class NavigationApi {
    /** @ngInject */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('notifications.list');
    }

    getByObjectId(objectId) {
        const params = {
            object_id: objectId
        };
        return this.$http.get(this.listUrl, { params }).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/notifications/notifications.service.js